/* ==========================================================================
   By Madinah — panier AJAX (brique commune)
   À déposer dans assets/ puis appeler dans layout/theme.liquid, AVANT
   bm-base.js, en script normal (pas defer) :
   <script src="{{ 'bm-cart.js' | asset_url }}"></script>

   Fournit window.BMCart, utilisé par :
   · snippets/bm-upsells.liquid (cases à cocher upsell)
   · sections/bm-panier-jauge.liquid (jauge de cadeaux)
   · le cadeau retrait magasin (poster 99 noms d'Allah)

   Reproduit exactement le flux AJAX natif du thème (js/common/product/
   product-form.js) : mêmes événements (cart:prepare-bundled-sections,
   variant:add, cart:change) pour que le tiroir panier et le mini-panier
   se mettent à jour tout seuls, sans rien connaître de ce fichier.
   ========================================================================== */
(function () {
  'use strict';

  function racineRoutes() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function sectionsAGrouper() {
    var sections = ['variant-added'];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } })
    );
    return sections;
  }

  function panierComplet(sectionsRendues) {
    return fetch(racineRoutes() + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (sectionsRendues) cart.sections = sectionsRendues;
        return cart;
      });
  }

  function diffuserAjout(cart, items) {
    document.dispatchEvent(
      new CustomEvent('variant:add', { bubbles: true, detail: { items: items, cart: cart } })
    );
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } })
    );
  }

  function diffuserChangement(cart) {
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:change', cart: cart } })
    );
  }

  /**
   * Ajoute une ou plusieurs lignes au panier en une seule requête.
   * items: [{ id: 123456, quantity: 1, properties: {...} }, ...]
   * Retourne une Promise résolue avec { cart, items } (items = lignes ajoutées, avec leur "key").
   */
  function ajouter(items) {
    if (!items || !items.length) return Promise.reject(new Error('Aucun article à ajouter'));
    var sections = sectionsAGrouper();
    return fetch(racineRoutes() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items, sections: sections.join(','), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          var msg = (res.json && (res.json.description || res.json.message)) || 'Erreur lors de l\'ajout au panier';
          throw new Error(msg);
        }
        var lignes = res.json.items || (res.json.id ? [res.json] : []);
        return panierComplet(res.json.sections).then(function (cart) {
          diffuserAjout(cart, lignes);
          return { cart: cart, items: lignes };
        });
      });
  }

  /**
   * Modifie la quantité d'une ligne existante (id de variante ou "key" de ligne).
   * quantite: 0 pour retirer la ligne.
   */
  function changer(idOuKey, quantite) {
    var sections = sectionsAGrouper();
    return fetch(racineRoutes() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: idOuKey, quantity: quantite, sections: sections.join(','), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          var msg = (res.json && (res.json.description || res.json.message)) || 'Erreur lors de la mise à jour du panier';
          throw new Error(msg);
        }
        res.json.sections = res.json.sections || {};
        return panierComplet(res.json.sections).then(function (cart) {
          diffuserChangement(cart);
          return { cart: cart };
        });
      });
  }

  /** Relit le panier courant (utilisé par la jauge de cadeaux au chargement de page). */
  function lire() {
    return fetch(racineRoutes() + 'cart.js').then(function (r) { return r.json(); });
  }

  /** Trouve la ligne du panier correspondant à une propriété cachée précise (ex: _bm_upsell). */
  function trouverLigne(cart, cle, valeur) {
    if (!cart || !cart.items) return null;
    for (var i = 0; i < cart.items.length; i++) {
      var p = cart.items[i].properties || {};
      if (p[cle] === valeur) return cart.items[i];
    }
    return null;
  }

  window.BMCart = { ajouter: ajouter, changer: changer, lire: lire, trouverLigne: trouverLigne, racineRoutes: racineRoutes };
})();
